export default class PaymentService {
    /* @ngInject */
    constructor($q, apiService) {
        this.$q = $q;
        this.apiService = apiService;
    }

    getBuyUrl(subscriptionId) {
        return this.apiService.post('/subscriptions/avangate/buy-link', null, {
            params: {
                subscriptionId
            }
        }).then((result) => {
            if (result.data && result.data.link) {
                return result.data.link;
            }
            return this.$q.reject(new Error('No payment link received'));
        }).catch((error) => {
            return this.$q.reject(error);
        });
    }

    confirm(avangateCtrl, token) {
        return this.apiService.post('/subscriptions/avangate/payments', {
            avangateCtrl,
            token
        });
    }
}



// WEBPACK FOOTER //
// ./src/application/service/payment/payment.service.js